import Vue from 'vue';
var focusDirective = function () {
    // Register a global custom directive called `v-focus`
    Vue.directive('focus', {
        // When the bound element is inserted into the DOM...
        inserted: function (el) {
            // Focus the element
            el.focus();
        }
    });
};
export default focusDirective;



//////////////////
// WEBPACK FOOTER
// ./src/components/directives/FocusDirective.ts
// module id = 52WZ
// module chunks = 18